import { render, staticRenderFns } from "./yanqing.vue?vue&type=template&id=e96d765c&scoped=true"
import script from "./yanqing.vue?vue&type=script&lang=js"
export * from "./yanqing.vue?vue&type=script&lang=js"
import style0 from "./yanqing.vue?vue&type=style&index=0&id=e96d765c&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96d765c",
  null
  
)

export default component.exports